//文件下载 兼容所有
/**
 *  @param href 文件的下载地址
 *  @param filename 文件下载后显示的名称
 */

import getExplore from './getExplore';

function downFile(href, filename) {
  let explore = getExplore();
  var a = document.createElement('a');
  a.href = href;
  a.style.display="none";
  a.download = filename;
  console.log(explore,"pppppp")
  if(explore.indexOf('Firefox')!=1){
    document.body.appendChild(a);
  }
  a.click();
  
}
export default downFile;


// WEBPACK FOOTER //
// ./src/common/js/utils/downFile.js